import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';

import LearningLayout from '../components/LearningLayout';
import storage from '../../../../../lib/Storage';
import { careGuideSetAccess } from '../../../../../state/modules/careGuides/actions';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state, ownProps) => {
  const activeId = state.careGuides.get('activeId') ?? ownProps.match.params.id;

  const careGuide = activeId
    ? denormalize(
        state.entities.getIn(['careGuides', activeId]),
        schema.careGuide,
        state.entities.toJS()
      )
    : null;

  return {
    careGuide: careGuide,
    careGuideId: activeId,
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    isCareGuideLoading: careGuide === undefined ? true : false,
    isCareGuideActive:
      careGuide && careGuide.account && careGuide.account.is_subscription_valid,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setActiveAccess: (data) => {
      dispatch(careGuideSetAccess(data));
    },
  };
};

const LearningLayoutContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningLayout);

export default LearningLayoutContainer;
